import React, { useEffect, useState, useContext } from 'react';
import { Modal, Form, Row, Col, Input, Button, Switch, Upload, Select, message } from 'antd';
import { CloseOutlined, SaveOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import { ModalContext } from '../../../shared/context/ModalContext';
import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { DOCUMENT_PRODUCT, DOCUMENT_COVER, LISTENER_COVERS } from '../../../shared/types/firestoreType';

import imageCompression from 'browser-image-compression';
import commonCloudStorage from '../../services/CommonCloudStorage';

import global from '../../../shared/utility/global';
import cover from '../../../assets/icons/image/01.svg';

import Loading from '../../../shared/components/Loading/Index';

import './styles.css'
import { debugErrorMap } from 'firebase/auth';

export default function FormModal(props) {
    const modal = useContext(ModalContext);
    const productFirestore = new CommonCloudFirestore(DOCUMENT_PRODUCT);
    const coverFirestore = new CommonCloudFirestore(DOCUMENT_COVER);

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [file, setFile] = useState(undefined);
    const [products, setProducts] = useState([]);

    const config = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1900,
        useWebWorker: true,
    };

    useEffect(() => {
        form.setFieldsValue({
            visible: true,
            productIds: []
        });
        onLoad();
    }, [props.open]);

    const onLoad = async () => {
        setLoading(true);

        const _products = await productFirestore.getDocuments();
        setProducts(_products);

        if (!props.id)
        {
            setLoading(false);
            return;
        }

        const response = await coverFirestore.getDocumentById(props.id);
        form.setFieldsValue(response);
        setFile({ url: response.imageUrl });

        setLoading(false);
    }

    const onSave = async () => {
        var validations = await form.validateFields().then(() => true).catch(() => false);
        if (!validations) {
            message.warning('Por favor completa los datos del formulario.', 7);
            return;
        }

        if (file === undefined) {
            message.warning('Por favor agregue una imagen.', 7);
            return;
        }

        modal.confirm("¿Esta seguro de realizar la acción?", async () => {
            setLoading(true);

            if (!file.url) {
                const blobFile = await imageCompression(file, config);
                const stringBase64File = await global.blobToBase64(blobFile);
                var imageUrl = await commonCloudStorage.uploadFromStringBase64(stringBase64File, `${DOCUMENT_COVER}/` + file.storageFilename);
                if (!imageUrl) {
                    message.error('Ocurrió un error al subir la imagen, por favor vuelva a intentarlo.', 7);
                    return;
                }
            }

            var documentData = form.getFieldsValue();
            documentData.imageUrl = !file.url ? imageUrl : file.url;
            documentData.title = documentData.title ?? '';
            documentData.subTitle = documentData.subTitle ?? '';
            documentData.index = !documentData.index ? 0 : documentData.index; 

            var response = await coverFirestore.setDocument(props.id, documentData, [LISTENER_COVERS]);
            if (response)
                message.success(`Portada ${props.id === '' ? 'registrada' : 'modificada'} correctamente.`, 7);
            else
                message.error('Ocurrió un error inesperado.', 7);

            setLoading(false);
            onCancel();
            setFile(undefined);
            props.onLoad();
        });
    }

    const onBefore = async (file) => {
        const allowedExtensions = ["image/png", "image/jpg", "image/jpeg", "image/gif", "image/tiff", "image/svg+xml", "image/webp"];
        const allowedExtensionsValid = allowedExtensions.includes(file.type);

        if (!allowedExtensionsValid) {
            message.error(`${file.name} no es una imagen valida.`, 7);
            return;
        }

        file.stringBase64 = await global.getBase64(file);
        file.storageFilename = uuidv4() + '.' + file.name.split('.')[file.name.split('.').length - 1];
        setFile(file);
    };

    const onCancel = (prop) => {
        if (prop === undefined || !prop?.target?.className?.toString().match("ant-modal-wrap") || prop?.type === "keydown") {
            form.resetFields();
            props.onCancel();
            setFile(undefined);
        }
    };

    return (
        <Modal
            title={props.id === '' ? "Nueva Portada" : "Modificar Portada"}
            open={props.open}
            destroyOnClose={true}
            onCancel={onCancel}
            width={600}
            footer={[
                <Button key="1" onClick={onCancel}>
                    <CloseOutlined /> Cancelar
                </Button>,
                <Button key="2" onClick={onSave} type={'primary'}>
                    <SaveOutlined /> Guardar
                </Button>
            ]}
        >
            <Loading visible={loading} label="cargando">
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Row gutter={15}>
                        <Col span={24} className='mt-20 mb-30'>
                            <div className='catalog-card-content'>
                                <div className='catalog-card-item'>
                                    <div className="vertical-center h-100">
                                        <img src={file === undefined ? cover : file.stringBase64 ?? file.url} alt="card" />
                                    </div>
                                </div>
                                <div className='catalog-card-info'>
                                    <div className="flex-parent">
                                        <div className="flex-child long-and-truncated">
                                            <div className='ml-5' style={{ whiteSpace: 'normal' }}>
                                                *.png *.jpg *.jpeg *.gif *.tiff *.svg *.webp
                                            </div>
                                        </div>
                                        <div className="flex-child short-and-fixed">
                                            <div className='mt-5'>
                                                <Upload
                                                    multiple={false}
                                                    showUploadList={false}
                                                    beforeUpload={onBefore}
                                                >
                                                    <Button
                                                        type="text"
                                                        shape='round'
                                                        icon={<FolderOpenOutlined />}
                                                    >
                                                        Subir Imagen
                                                    </Button>
                                                </Upload>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Título"
                                name="title"
                                className='input-material'
                            >
                                <Input
                                    size='large'
                                    placeholder="Ingresar nombre"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Subtítulo"
                                name="subTitle"
                                className='input-material'
                            >
                                <Input
                                    size='large'
                                    placeholder="Ingresar subtítulo"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Productos"
                                name="productIds"
                                className='input-material mb-15'
                            >
                                <Select
                                    size='large'
                                    mode="multiple"
                                    showSearch
                                    allowClear
                                    optionFilterProp="children"
                                    placeholder="Agregar productos . . ."
                                >
                                    {products.map(item => (
                                        <Select.Option
                                            key={item.id}
                                            value={item.id}
                                            label={item.name}
                                        >
                                            {item.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Visible"
                                name="visible"
                                valuePropName="checked"
                            >
                                <Switch defaultChecked checkedChildren="SÍ" unCheckedChildren="NO" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Loading>
        </Modal>
    );
}